import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-upload-item', 'remove', 'Noņemt');
